import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const SITE_URL = import.meta.env.VITE_SITE_URL ?? 'https://greenlyelectronicsrecycling.com';

const AboutJsonLd = () => (
  <script type="application/ld+json">{JSON.stringify({
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "AboutPage",
        "@id": `${SITE_URL}/about#webpage`,
        "url": `${SITE_URL}/about`,
        "name": "About Greenly Electronics Recycling | Los Angeles E-Waste Nonprofit",
        "description": "Greenly is a subsidiary of Bridge The Digital Divide, a 501(c) nonprofit. We recycle, refurbish, and redistribute electronics to underserved LA communities while reducing e-waste.",
        "isPartOf": { "@id": `${SITE_URL}/#website` },
        "about": {
          "@type": "Organization",
          "@id": `${SITE_URL}/#business`,
          "name": "Greenly Electronics Recycling",
          "description": "Greenly a subsidiary of Bridge The Digital Divide — a 501(c) non-profit organization founded to address the growing problem of e-waste and the increasing digital divide in Los Angeles.",
          "foundingDate": "2010",
          "areaServed": "Los Angeles, CA",
          "url": `${SITE_URL}`
        },
        "breadcrumb": { "@id": `${SITE_URL}/about#breadcrumb` }
      },
      {
        "@type": "BreadcrumbList",
        "@id": `${SITE_URL}/about#breadcrumb`,
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Home", "item": `${SITE_URL}/` },
          { "@type": "ListItem", "position": 2, "name": "About Us", "item": `${SITE_URL}/about` }
        ]
      },
      {
        "@type": "Organization",
        "@id": `${SITE_URL}/#business`,
        "name": "Greenly Electronics Recycling",
        "url": `${SITE_URL}`,
        "foundingDate": "2010",
        "description": "Greenly a subsidiary of Bridge The Digital Divide — a 501(c) non-profit organization founded to address the growing problem of e-waste and the increasing digital divide in Los Angeles.",
        "areaServed": "Los Angeles, CA",
        "telephone": "+12136001000",
        "email": "info@greenly.us",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "2542 W. 3rd Street",
          "addressLocality": "Los Angeles",
          "addressRegion": "CA",
          "postalCode": "90057",
          "addressCountry": "US"
        }
      }
    ]
  })}</script>
);

const AboutPage = () => (
  <>
    <title>About Greenly Electronics Recycling | Los Angeles E-Waste Nonprofit</title>
    <meta name="description" content="Greenly is a subsidiary of Bridge The Digital Divide, a 501(c) nonprofit. We recycle, refurbish & redistribute electronics to underserved LA communities. CalRecycle certified since 2010." />
    <meta name="keywords" content="about Greenly Electronics Recycling, Los Angeles e-waste nonprofit, Bridge The Digital Divide, electronics recycling mission" />
    <meta name="robots" content="index, follow" />
    <meta name="last-modified" content="2026-05-11" />
    <link rel="canonical" href={`${SITE_URL}/about`} />
    <AboutJsonLd />
    <Navbar />
    <main className="min-h-screen bg-[#F7F9F7] pt-24 pb-16">
      <div className="max-w-3xl mx-auto px-4 md:px-6">

        {/* Card */}
        <div className="bg-white border border-gray-200 rounded-xl overflow-hidden">

          {/* About Us badge */}
          <div className="px-8 pt-8 pb-2">
            <span className="inline-block bg-[#1B6B3A] text-white text-xs font-semibold px-4 py-1.5 rounded-md">
              About Us
            </span>
          </div>

          {/* Section 1 */}
          <div className="px-8 pt-6 pb-8 text-center">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 leading-snug">
              Recycle &amp; Reuse –<br />Makes all the Difference
            </h1>
            <p className="text-sm md:text-base text-gray-600 leading-relaxed max-w-2xl mx-auto">
              Greenly a subsidiary of Bridge The Digital Divide — a 501(c) non-profit organization founded among other objectives to address the growing problem of e-waste and the increasing &apos;digital divide&apos;. We offer simple solutions to help individuals and organizations prevent operational equipment from premature destruction. With a focus on recovery, refurbishment and reuse. After the devices have been repaired and refurbished, we freely distribute the re-purposed technology to low-income youth and their families, veterans in need, the elderly and the homeless in our SoCal communities. We believe that reuse before recycling is critical in managing the waste created by computer hardware, and by offering industry-leading data destruction for all equipment we receive, we have securely repurposed hundreds of tons of equipment. Because not everything we receive can be reasonably repurposed, we have partnered with certified recycling organizations to process equipment that has reached the end of its productive life.
            </p>
          </div>

          {/* Divider */}
          <hr className="border-gray-200 mx-8" />

          {/* Section 2 */}
          <div className="px-8 pt-8 pb-10 text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
              What We Do
            </h2>
            <p className="text-sm md:text-base text-gray-600 leading-relaxed max-w-2xl mx-auto">
              Greenly Electronics Recycling&apos;s key mandate is to reduce electronic waste. Most households and businesses have unwanted electronics taking up valuable storage space because they aren&apos;t aware of disposal options or are concerned about data security on their devices. We prevent unwanted computers, laptops and related electronic equipment from being prematurely destroyed or recycled by offering American organizations and individuals secure and accessible disposal options. By focusing on the recovery, refurbishment and reuse of electronics, we are able to maximize their life cycle while providing a necessary service to the public and valuable IT hardware donations to charities and other non-profit organizations. Our secondary course of action, when equipment does not exhibit any reuse potential, is to recycle computer equipment. Greenly Electronics Recycling works with established recyclers to ensure all materials not suitable for donation are appropriately recycled in a responsible, secure and environmentally friendly manner.
            </p>
          </div>

        </div>
      </div>
    </main>
    <Footer />
  </>
);

export default AboutPage;
